<template>
  <div>
    <div class="sww-container" v-if="fromEasy && responseStatus !== 401">
      <h3 class="sww-title">{{ $t('somethingWentWrong') }}</h3>
      <p>
        <span v-if="text !== ''" v-html="$t('somethingWentWrongInfo', { text })" />
        {{ $t('tryAgainLater') }}
        <a href="#" class="reload-link" @click.stop.prevent="reloadPage">{{ $t('reloadPage') }}</a>
      </p>
    </div>
    <div v-else-if="responseStatus === 401 && fromEasy">
      <h3 class="sww-title">The activation link has expired.</h3>
      <p>
        {{ $t('resendEmail') }}
        <router-link to="/email" class="email-link">Resend Email</router-link>
      </p>
    </div>
    <div class="sww-container" v-if="!fromEasy">
      <h3 class="sww-title">{{ $t('somethingWentWrong') }}</h3>
      <p>
        <span v-if="text !== ''" v-html="$t('somethingWentWrongInfo', { text })" />
        {{ $t('tryAgainLater') }}
        <a href="#" class="reload-link" @click.stop.prevent="reloadPage">{{ $t('reloadPage') }}</a>
      </p>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'SomethingWentWrong',
    methods: {
      reloadPage () {
        window.location.reload()
      }
    },
    props: {
      text: {
        type: String,
        default: ''
      },
      fromEasy: {
        type: Boolean,
        default: false
      },
      responseStatus: {
        type: Number,
        default: null
      }
    }
  }
</script>

<style lang="scss">
  @import '../styles/variables.scss';

  .reload-link,
  .reload-link:hover {
    color: $primary;
  }
  .sww-container {
    position: fixed;
    width: 100%;
    height: 100%;
    background-color: $white;
    padding-top: 50px;
    top: 0;
    left: 0;
    display: flex;
    flex-flow: column;
    align-items: center;
    z-index: $serverErrorZIndex;
  }
  .sww-title {
    margin-bottom: 30px;
  }
  .email-link{
    font-weight:700;
    text-decoration: underline!important;
  }
</style>



// WEBPACK FOOTER //
// src/components/SomethingWentWrong.vue